import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IExchangeBalance } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getCexBalancesConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_exchange_balance', timeframe)) as IExchangeBalance[]

	const series1 = chartData.map((element: IExchangeBalance) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.BINANCE_BALANCE }
	})
	const series2 = chartData.map((element: IExchangeBalance) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.BYBIT_BALANCE }
	})
	const series3 = chartData.map((element: IExchangeBalance) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.KUCOIN_BALANCE }
	})
	const series4 = chartData.map((element: IExchangeBalance) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.KRAKEN_BALANCE }
	})
	const series5 = chartData.map((element: IExchangeBalance) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_BALANCE }
	})
	const config: IChart[] = [
		{
			data: series5,
			strokeWidth: 2,
			name: 'Total',
			type: 'line',
			seriesGroup: ' [rune]',
			color: `black`,
			unitSymbol: 'ᚱ'
		},
		{
			data: series1,
			strokeWidth: 2,
			name: 'Binance balance',
			type: 'bars',
			seriesGroup: '[rune]',
			color: `${colors[0]}`,
			unitSymbol: 'ᚱ',
			barGroup: 'balance'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'Bybit balance',
			type: 'bars',
			seriesGroup: '[rune]',
			color: `${colors[1]}`,
			unitSymbol: 'ᚱ',
			barGroup: 'balance'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'kuCoin balance',
			type: 'bars',
			seriesGroup: '[rune]',
			color: `${colors[2]}`,
			unitSymbol: 'ᚱ',
			barGroup: 'balance'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'Kraken balance',
			type: 'bars',
			seriesGroup: '[rune]',
			color: `${colors[3]}`,
			unitSymbol: 'ᚱ',
			barGroup: 'balance'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const CexBalances = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getCexBalancesConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="CEX Balances"
			chartDesc="RUNE balances held on major centralized exchanges. Indicates potential sell pressure or liquidity on CEXs."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="80fc0008-8615-4117-8a8a-4d965d322376"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default CexBalances
